module.exports = __webpack_public_path__ + "7ff44f9aa5089327100184e14c4f201e.pdf";